import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseService } from 'projects/assist/src/app/_shared/services/base.service';
import { TranslationTextBasic } from 'projects/assist/src/app/custom-entity/models/translation-text';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationTextService extends BaseService<
  TranslationTextBasic,
  TranslationTextBasic
> {
  constructor(
    protected override http: HttpClient,
    @Inject('BASE_URL') protected override baseUrl: string
  ) {
    super(http, baseUrl, 'TranslationText');
  }

  getAllByPage(page: string, accessKey: string): Observable<TranslationTextBasic[]> {
    return this.getAll('/byPage/' + page + '?accessKey=' + accessKey);
  }

  getAllByEntity(entityId: number, accessKey: string): Observable<TranslationTextBasic[]> {
    return this.getAll('/byEntity/' + entityId + '?accessKey=' + accessKey);
  }
}
